var gsap = require('gsap'),
	common = require('../base/common'),
	emitter = require('../base/emitter');

function Header(){

	var _this = this;
	_this.$el = $('#header');
	_this.$menu = _this.$el.find('.header-menu');
	_this.$menuToggle = _this.$el.find('.header-menu_trigger');
	_this.$menuWrap = _this.$el.find('.header-nav');
	_this.$menuItems = _this.$menuWrap.find('a');
	_this.$menuPrimary = _this.$menuWrap.find('.primary-level');
	_this.$menuSecondary = _this.$menuWrap.find('.secondary-level');
	_this.menuOpen = false;

	// menu functions

	_this.$menuToggle.on('click', function(e){
		if(!_this.menuOpen)
			_this.menuShow();
		else
			_this.menuHide();
	})

	_this.$menuItems.on('click', function(e){
		var $a = $(this)
		if($a.data('level')){
			e.preventDefault();
			_this.menuLevel($a.data('level'));
		}

	})

	// contacts functions

	_this.contactsOpen = false;
	_this.$contacts = _this.$el.find('.header-contacts');
	_this.$contactsToggle = _this.$el.find('.header-contacts_trigger');
	_this.$contactsBg = _this.$contacts.find('.header-contacts_bg');
	_this.$contactsForm = _this.$el.find('.header-contacts_form');
	_this.contactsToggleText = _this.$contactsToggle.html();

	_this.$contactsToggle.on('click', function(e){
		if(!_this.contactsOpen)
			_this.contactsShow();
		else{
			_this.contactsHide();
		}
	})

	emitter.on('page:resize', function(){
		_this.resize();
	})

	emitter.on('contacts:opening', function(){

		_this.menuHide();

	})

	emitter.on('header:hide', function(){
		_this.menuHide();
		_this.contactsHide();
	})

	emitter.on('scroll:disable', function(){

		common.$body.data('scroll-top', common.$window.scrollTop());
		common.$body.css({
			'position': 'fixed',
			'top': (-common.$window.scrollTop()) + 'px',
			'left': '0px',
			'overflow-y': 'scroll'
		})

	})

	emitter.on('scroll:enable', function(){

		common.$body.css({
			'position': 'static',
			'left': 'auto',
			'overflow-y': 'visible'
		})
		TweenLite.set(window, {scrollTo:{y: common.$body.data('scroll-top') }});

	})

}

Header.prototype.resize = function(){

	var _this = this;
	if(_this.menuOpen){
		TweenMax.set(_this.$menuWrap, {
			height: common.$window.height() - _this.$menuWrap.offset().top
		})
	}
	if(_this.contactsOpen){
		TweenMax.set(_this.$contactsBg, { width: (common.screen.width >= 1024 ? _this.$contactsForm.outerWidth() + 200 : common.screen.width) });
		TweenMax.set(_this.$contactsBg, { height: common.$window.height() - _this.$contactsBg.offset().top });
	}else{
		TweenMax.set(_this.$contactsBg, { height: _this.$contactsToggle.outerHeight() })
		TweenMax.set(_this.$contactsBg, { width: _this.$contactsToggle.outerWidth() })
	}

}


// MENU FUNCTIONS

Header.prototype.menuShow = function(){

	var _this = this;
	_this.menuOpen = true;
	_this.$menuToggle.addClass('active');
	common.$body.addClass('show-menu');

	emitter.emit('menu:opening');
	emitter.emit('scroll:disable');

	if(_this.contactsOpen)
		_this.contactsHide();

	TweenMax.fromTo(_this.$menuWrap, 0.6, {
		height: 0
	},{
		height: common.$window.height()  - parseInt(_this.$menuWrap.css('top').replace('px','')),
		ease: Power3.easeInOut, 
		onComplete: function(){
			emitter.emit('menu:opened');
		}
	})

}

Header.prototype.menuHide = function(){

	var _this = this;
	_this.menuOpen = false;
	_this.$menuToggle.removeClass('active');

	emitter.emit('menu:closing');
	emitter.emit('scroll:enable');

	TweenMax.to(_this.$menuWrap, 0.6, {
		height: 0,
		ease: Power3.easeInOut,
		onComplete: function(){
			_this.menuLevel('primary');
			emitter.emit('menu:closed');
			common.$body.removeClass('show-menu');
		}
	})

}

Header.prototype.menuLevel = function(toLevel){

	var _this = this;
	var $secondary = _this.$menuSecondary.filter('.active');
	if(toLevel == 'primary'){

		if(!$secondary.length) return;
		TweenMax.to($secondary,0.3,{
			x: _this.$menuWrap.width(),
			onComplete: function(){
				$secondary.removeClass('active');
				$secondary.find('.secondary-level-inner').animate({scrollTop:0},10);
			}
		})
		TweenMax.to(_this.$menuPrimary,0.3,{
			opacity: 1,
			scale: 1,
			onComplete: function(){
				_this.$menuPrimary.removeClass('behind')
				$secondary.removeAttr('style');
			}
		})

	}else{
		var $secondary = _this.$menuSecondary.filter('#level--'+toLevel);
		TweenMax.to(_this.$menuPrimary,0.3,{
			opacity: 0,
			scale: 0.9
		})
		TweenMax.to($secondary,0.3,{
			x: 0,
			onComplete: function(){
				_this.$menuPrimary.addClass('behind')
				$secondary.addClass('active');

			}
		})

	}

}

// CONTACTS FUNCTIONS

Header.prototype.contactsShow = function(){

	var _this = this;
	_this.contactsOpen = true;
	common.$body.addClass('show-contacts');

	emitter.emit('scroll:disable');

	if(_this.menuOpen)
		_this.menuHide();

	var tl = new TimelineMax({
		ease: Power3.easeInOut,
		onComplete: function(){

			TweenMax.to(_this.$contactsForm, 0.5, { opacity:1 })
			_this.$contactsToggle.addClass('closing');
			_this.$contactsToggle.html('<span class="txt">'+_this.$contactsToggle.data('close') + '</span><span class="ico"></span>');

		}
	});

	var offTop = common.$window.height() - parseInt(_this.$contactsBg.css('top').replace('px',''));

	tl.add(	TweenMax.to(_this.$contactsBg, 0.5, { width: (common.screen.width >= 1024 ? _this.$contactsForm.outerWidth() + 200 : common.screen.width), height: offTop }))



}

Header.prototype.contactsHide = function(){

	var _this = this;
	_this.contactsOpen = false;

	emitter.emit('scroll:enable');

	TweenMax.to(_this.$contactsForm, 0.5, { opacity: 0, onComplete: function(){

		var tl = new TimelineMax({
			ease: Power3.easeInOut,
			onComplete: function(){
				common.$body.removeClass('show-contacts');
				_this.$contactsToggle.removeClass('closing');
				_this.$contactsToggle.html(_this.contactsToggleText);
				_this.$contactsForm.animate({scrollTop:0},10);

				// reset form

				_this.$contactsForm.find('form').trigger('reset');


			}
		});
		tl.add(	TweenMax.to(_this.$contactsBg, 0.5, { width: _this.$contactsToggle.outerWidth(), height: _this.$contactsToggle.outerHeight() }))

	} })


}

module.exports = Header;


/** WEBPACK FOOTER **
 ** ./layouts/header.js
 **/